<div>
  <input [disabled]="disabled" type="file" class="invisible" [accept]="accept" [multiple]="multiple" #fileSelector
    (change)="uploadListener($event)">

  <div (click)="fileSelector.click()" class="flex gap-2">
    <div class="w-full h-9.5 rounded-sm border border-gray-400"></div>
    <ig-button theme [disabled]="disabled" (trigger)="fileSelector.click()">select</ig-button>
  </div>
</div>